import React from 'react';
import PropTypes from 'prop-types';
import FamilyTree from './familyTree/FamilyTree';
import FamilyTreeSummary from './familyTree/FamilyTreeSummary';
import FlatJumpsTables from './relativesTable/FlatJumpsTables';

const Pedigree = ({ data: {
    pedigree,
    relatives,
    weatherbysPedigreeUrl,
} }) => (
    <section>
        <FamilyTreeSummary {...pedigree} />
        <p>{pedigree.rpFormText}</p>
        { !weatherbysPedigreeUrl && <FamilyTree pedigree={pedigree} />
        }
        <FlatJumpsTables
            data={relatives || {}}
            disclaimerName="Relatives"
            flatTitle="Relatives - Flat (GB & IRE)"
            jumpsTitle="Relatives - jumps (GB & IRE)"
            flatNoData="No relatives that ran on the Flat in our records"
            jumpsNoData="No relatives that ran over jumps in our records"
        />
    </section>
);

Pedigree.propTypes = {
    data: PropTypes.shape({
        profile: PropTypes.shape({
            weatherbysUid: PropTypes.string,
        }),
        weatherbysPedigreeUrl: PropTypes.string,
        relatives: PropTypes.shape({
            FLAT: PropTypes.arrayOf(PropTypes.shape({ horseUid: PropTypes.number })),
            JUMPS: PropTypes.arrayOf(PropTypes.shape({ horseUid: PropTypes.number })),
        }),
        pedigree: PropTypes.shape({
            horseName: PropTypes.string,
            horseUid: PropTypes.number,
        }).isRequired,
    }).isRequired,
};

export default Pedigree;



// WEBPACK FOOTER //
// ./src/js/horse/pedigree/Pedigree.jsx